import React from 'react';
import {Link} from "react-router";
import {forgotPasswordService} from "../services/employee";
import {AxiosError} from "axios";
import Label from "../components/Label";
import Input from "../components/input/InputField";
import Button from "../components/button/Button";
import AuthLayout from "../components/AuthPageLayout";

export type Msg = {
    msg: string;
}

const ForgotPassword = () => {
    const [email, setEmail] = React.useState<string>("");
    const [loading, setLoading] = React.useState(false);
    const [errors, setError] = React.useState("");
    const [success, setSuccess] = React.useState("");

    const submitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (loading) return;
        setLoading(true);
        setError("");

        if (email.length <= 0) {
            setError("Email is required");
            setLoading(false);
            return;
        }

        try {
            const result = await forgotPasswordService(email)
            const data: Msg = result.data;
            setSuccess(data.msg);
            setLoading(false);
        } catch (error) {
            if (error instanceof AxiosError) {
                setError(error.response?.data?.error);
                setLoading(false);
                return;
            }
            setError("Something went wrong!");

        }

    }

    return (

        <AuthLayout>
            <div className="flex flex-col flex-1">

                <div className="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
                    <div>
                        <div className="mb-5 sm:mb-8">
                            {
                                errors.length > 0 && (
                                    <small className={`px-2 py-1.5 ring-1 ring-red-500 bg-red-300/70 rounded-md text-red-500`}>{errors}</small>
                                )
                            }
                            {
                                success.length > 0 && (
                                    <div className={`w-full h-fit mt-4 bg-emerald-500/20 rounded-sm`}>
                                        <p className={`w-full text-center px-2 py-1.5  ring-1 ring-emerald-500 text-sm text-emerald-500 font-semibold rounded-sm`}>{success}</p>
                                    </div>
                                )
                            }
                            <h1 className="mb-2 text-xl md:text-2xl lg:text-4xl max-lg:text-center font-semibold text-gray-800 text-title-smcsm:text-title-md">
                                Reset Your Password!
                            </h1>
                            <div className="lg:hidden flex flex-col items-center justify-center w-full mb-2">
                                <Link to="/" className="block">
                                    <img
                                        width={231}
                                        height={48}
                                        src="https://kmcwebsite.nyc3.cdn.digitaloceanspaces.com/assets/images/logo.png"
                                        alt="Logo"
                                    />
                                </Link>
                                {/*<p className="text-center text-gray-900">*/}
                                {/*    Kiira Integrated Information Systems*/}
                                {/*</p>*/}
                            </div>
                            <p className="text-xs md:text-sm max-lg:text-center  text-gray-500">
                                Enter the email address linked to your account, and we’ll send you a link to reset your password.
                            </p>
                        </div>
                        <div>
                            <form onSubmit={submitHandler}>
                                <div className="space-y-4 lg:space-y-6">
                                    <div>
                                        <Label>
                                            Email <span className="text-red-500">*</span>{" "}
                                        </Label>
                                        <Input
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            type={"email"} placeholder="jon@kiiramotors.com" />
                                    </div>
                                    <div>
                                        <Button disabled={loading} className="w-full" size="sm">
                                            {loading? "Sending..." : success.length > 0 ? "Send Again":"Send Reset Link"}
                                        </Button>
                                    </div>
                                    <div className="flex flex-row items-center md:gap-0.5 lg:gap-2 justify-start">
                                        <p className={`max-sm:hidden text-sm`}>Wait, I remember my password...</p>
                                        <Link
                                            to="/login"
                                            className="text-sm text-orange-500 hover:text-orange-600"
                                        >
                                            Let me try again
                                        </Link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </AuthLayout>
    );
};

export default ForgotPassword;